import request from '@/router/axios'
// 常见故障分页
export function getCommonFaultPage (query) {
    return request({
      url: '/api/alarmCommonExplain/page',
      method: 'get',
      params: query
    })
}
// 常见故障类型
export function getCommonType (query) {
    return request({
      url: '/api/alarmCommonExplain/listAlarmType',
      method: 'get',
      params: query
    })
}
// 临时故障分页
export function getTempFaultPage (query) {
    return request({
      url: '/api/alarmTempExplain/page',
      method: 'get',
      params: query
    })
}
// 临时故障类型
export function getTempType (query) {
    return request({
      url: '/api/alarmTempExplain/listAlarmType',
      method: 'get',
      params: query
    })
}
// 获取创建人列表
export function getCreaterList (query) {
  return request({
    url: '/api/areaArchive/list',
    method: 'get',
    params: query
  })
}
// 新增常见故障
export function addNewCommonItem (obj) {
  return request({
    url: '/api/alarmCommonExplain',
    method: 'post',
    data: obj
  })
}
// 新增临时故障
export function addNewTempItem (obj) {
  return request({
    url: '/api/alarmTempExplain',
    method: 'post',
    data: obj
  })
}
// 常见故障详情
export function commonDetail(id) {
  return request({
    url: '/api/alarmCommonExplain/' + id,
    method: 'get',
  })
}
// 临时故障详情
export function tempDetail(id) {
  return request({
    url: '/api/alarmTempExplain/' + id,
    method: 'get',
  })
}
// 临时故障详情
export function deleteCommonItem(id) {
  return request({
    url: '/api/alarmCommonExplain/' + id,
    method: 'delete',
  })
}
// 临时故障详情
export function deleteTempItem(id) {
  return request({
    url: '/api/alarmTempExplain/' + id,
    method: 'delete',
  })
}
// 修改常见故障
export function editCommonItem (obj) {
  return request({
    url: '/api/alarmCommonExplain',
    method: 'put',
    data: obj
  })
}
// 修改临时故障
export function editTempItem (obj) {
  return request({
    url: '/api/alarmTempExplain',
    method: 'put',
    data: obj
  })
}